package br.com.htms.inspeccaocampo.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.TopAppBar
import br.com.htms.inspeccaocampo.data.colaboradores.ColabEscopo
import br.com.htms.inspeccaocampo.platform.rotuloPortalDoEndereco
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import br.com.htms.inspeccaocampo.ui.theme.TemaPortal
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.form.AppTab
import br.com.htms.inspeccaocampo.form.HubSecao
import br.com.htms.inspeccaocampo.ui.screens.SharedFuncionariosScreen
import br.com.htms.inspeccaocampo.form.EnvioProgresso
import kotlinx.coroutines.delay
import br.com.htms.inspeccaocampo.platform.PlatformBackHandler
import br.com.htms.inspeccaocampo.platform.platformName
import br.com.htms.inspeccaocampo.shared.ui.components.CenteredAppDialog
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import br.com.htms.inspeccaocampo.shared.ui.components.KeyboardDismissHost
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.ui.screens.ConfigHeaderActions
import br.com.htms.inspeccaocampo.ui.screens.SharedChecklistAlojamentoScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedChecklistVetoresScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedComunicacaoOcorrenciasScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedConfigScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedChecklistDiarioScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedFormHubScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedHistoricoScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedLoginScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedRelatorioAlojamentoScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedRelatorioFotoScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedAcompanhamentoAmbientalScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedEvidenciaTreinamentoScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedAnaliseVisualNrScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedRemSegurancaScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedRelatorioSegurancaScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedOrdemServicoScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedAprScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedAtivosScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedColaboradoresScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedEfetivoScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedEstoqueScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedDashboardsScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedOcorrenciasScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedCertificadoScreen
import br.com.htms.inspeccaocampo.ui.screens.SharedFichaEpiScreen

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedAppNav(controller: AppController) {
    val tab by controller.tab.collectAsState()
    val appConfig by controller.appConfig.collectAsState()
    val mensagem by controller.mensagem.collectAsState()
    val envio by controller.envioProgresso.collectAsState()
    val rascunho by controller.rascunhoRestaurado.collectAsState()
    val authReady by controller.authReady.collectAsState()
    val authUser by controller.authUser.collectAsState()
    val snackbar = remember { SnackbarHostState() }
    val isWeb = platformName() == "Web"

    var mostrarSenha by remember { mutableStateOf(false) }
    var senha by remember { mutableStateOf("") }
    var erroSenha by remember { mutableStateOf(false) }
    val isAdmin = authUser?.isAdmin == true
    val isMaster = authUser?.isMaster == true
    val canEditAppConfig = authUser == null || authUser?.podeEditarCamposMaster == true
    val configHeaderActions = remember { ConfigHeaderActions() }
    val formTipoAtivo by controller.formTipoAtivo.collectAsState()

    LaunchedEffect(mensagem) {
        val msg = mensagem ?: return@LaunchedEffect
        snackbar.showSnackbar(msg)
        controller.consumirMensagem()
    }

    LaunchedEffect(rascunho) {
        if (rascunho) {
            snackbar.showSnackbar("Rascunho restaurado - seus dados foram recuperados.")
            controller.consumirAvisoRascunho()
        }
    }

    if (!authReady) {
        if (isWeb) {
            WebCenteredColumn(transparentCenter = true) {
                Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                    Text("Verificando sessão...", color = Color.White)
                }
            }
        } else {
            Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                Text("Verificando sessão...")
            }
        }
        return
    }

    if (controller.loginRequired && authUser == null) {
        val loginContent: @Composable () -> Unit = {
            KeyboardDismissHost {
                SharedLoginScreen(
                    onLoggedIn = { session -> controller.onLoginSuccess(session) },
                    embeddedInShell = isWeb
                )
            }
        }
        if (isWeb) {
            WebCenteredColumn(transparentCenter = true, content = loginContent)
        } else {
            loginContent()
        }
        return
    }

    if (mostrarSenha) {
        CenteredAppDialog(
            onDismissRequest = {
                mostrarSenha = false
                senha = ""
                erroSenha = false
            },
            title = "Configuração",
            confirmLabel = "Entrar",
            onConfirm = {
                if (controller.tentarAbrirConfig(senha)) {
                    mostrarSenha = false
                    senha = ""
                    erroSenha = false
                } else {
                    erroSenha = true
                }
            },
            dismissLabel = "Cancelar"
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Text("Digite a senha para abrir configuração e modo treinamento.")
                AppOutlinedTextField(
                    value = senha,
                    onValueChange = {
                        senha = it
                        erroSenha = false
                    },
                    label = { Text("Senha") },
                    modifier = Modifier.fillMaxWidth(),
                    isError = erroSenha,
                    visualTransformation = PasswordVisualTransformation(),
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.NumberPassword),
                    singleLine = true,
                    colors = FormFieldDefaults.textFieldColors()
                )
                if (erroSenha) {
                    Text("Senha incorreta.", color = MaterialTheme.colorScheme.error)
                }
            }
        }
    }

    val emAlojamento = tab == AppTab.FORM && formTipoAtivo in setOf(
        FormTipo.RELATORIO_FOTO_ALOJAMENTO,
        FormTipo.CHECKLIST_ALOJAMENTO,
        FormTipo.CHECKLIST_VETORES,
        FormTipo.RELATORIO_ALOJAMENTO
    )
    PlatformBackHandler(enabled = emAlojamento) {
        controller.solicitarSaidaDoFormulario { controller.voltarAoHub() }
    }

    val saidaPendente by controller.saidaPendente.collectAsState()
    if (saidaPendente != null) {
        val edicao = controller.saidaPendenteEhEdicao
        CenteredAppDialog(
            onDismissRequest = { controller.cancelarSaidaDoFormulario() },
            title = "Tem certeza que quer sair?",
            confirmLabel = "Sair",
            onConfirm = { controller.confirmarSaidaDoFormulario(descartar = false) },
            dismissLabel = "Continuar preenchendo"
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                Text(
                    if (edicao) {
                        "Você está editando um registro já salvo. As alterações feitas agora serão perdidas se sair sem salvar."
                    } else {
                        "O preenchimento e as fotos ficam guardados neste aparelho e voltam quando você abrir este formulário de novo."
                    }
                )
                if (!edicao) {
                    TextButton(onClick = { controller.confirmarSaidaDoFormulario(descartar = true) }) {
                        Text("Sair e descartar o preenchimento", color = MaterialTheme.colorScheme.error)
                    }
                }
            }
        }
    }

    val appScaffold: @Composable () -> Unit = {
        KeyboardDismissHost {
        Scaffold(
            modifier = Modifier.fillMaxSize(),
            containerColor = MaterialTheme.colorScheme.background,
            topBar = {
              Column {
                TopAppBar(
                    title = {
                        val formLabel = when (tab) {
                            AppTab.FORM -> formTipoAtivo.rotulo
                            AppTab.ORDEM_SERVICO -> "Ordem de Serviço (teste)"
                            AppTab.FUNCIONARIOS -> "Funcionários"
                            AppTab.FICHA_EPI -> "Ficha de EPI"
                            AppTab.CERTIFICADO -> "Certificados"
                            AppTab.APR -> "APR"
                            AppTab.ATIVOS -> "Controle de Ativos"
                            AppTab.COLABORADORES -> "Colaboradores"
                            AppTab.EFETIVO -> "Controle de Efetivo"
                            AppTab.OCORRENCIAS -> "Gestão de Ocorrências"
                            AppTab.DASHBOARDS -> "Dashboards"
                            AppTab.ESTOQUE -> "Estoque"
                            else -> rotuloPortalDoEndereco() ?: appConfig.nomeInspecao
                        }
                        val sub = buildString {
                            append(formLabel)
                            authUser?.let {
                                append(" - ")
                                append(it.username)
                                if (it.isAdmin) append(" (admin)")
                            }
                        }
                        HtmsHeaderTitle(subtitle = sub)
                    },
                    actions = {
                        TextButton(onClick = { TemaPortal.alternar() }) {
                            Text(if (TemaPortal.escuro) "Tema claro" else "Tema escuro")
                        }
                        if (tab == AppTab.FORM || tab == AppTab.ORDEM_SERVICO || tab == AppTab.FUNCIONARIOS || tab == AppTab.FICHA_EPI ||
                            tab == AppTab.CERTIFICADO || tab == AppTab.APR || tab == AppTab.COLABORADORES || tab == AppTab.EFETIVO || tab == AppTab.OCORRENCIAS ||
                            tab == AppTab.DASHBOARDS || tab == AppTab.ATIVOS || tab == AppTab.ESTOQUE
                        ) {
                            TextButton(onClick = { controller.solicitarSaidaDoFormulario { controller.voltarAoHub() } }) {
                                Text("Voltar")
                            }
                        }
                        if (tab == AppTab.CONFIG) {
                            TextButton(onClick = { configHeaderActions.onVoltar?.invoke() }) {
                                Text("Voltar")
                            }
                            if (canEditAppConfig) {
                                TextButton(onClick = { configHeaderActions.onSalvar?.invoke() }) {
                                    Text("Salvar / Aplicar")
                                }
                            }
                        }
                        if (authUser != null) {
                            TextButton(onClick = { controller.solicitarSaidaDoFormulario { controller.logout() } }) {
                                Text("Sair")
                            }
                        }
                        if (isMaster) {
                            TextButton(
                                onClick = {
                                    controller.solicitarSaidaDoFormulario {
                                        controller.abrirConfigComoAdmin()
                                    }
                                }
                            ) {
                                Text("Config")
                            }
                        }
                    },
                    colors = TopAppBarDefaults.topAppBarColors(
                        containerColor = PortalCores.Cartao,
                        titleContentColor = PortalCores.Navy,
                        actionIconContentColor = PortalCores.AzulIcone
                    )
                )
                HorizontalDivider(color = PortalCores.Borda)
              }
            },
            bottomBar = {
                if (tab != AppTab.CONFIG && tab != AppTab.ATIVOS && tab != AppTab.COLABORADORES && tab != AppTab.EFETIVO && tab != AppTab.OCORRENCIAS &&
                    tab != AppTab.FUNCIONARIOS && tab != AppTab.ORDEM_SERVICO && tab != AppTab.FICHA_EPI &&
                    tab != AppTab.CERTIFICADO && tab != AppTab.APR &&
                    tab != AppTab.DASHBOARDS && tab != AppTab.ESTOQUE && !(tab == AppTab.FORM && formTipoAtivo == FormTipo.REM_SEGURANCA_OBRAS)
                ) {
                    Surface(
                        color = PortalCores.Cartao,
                        border = PortalCores.BordaCartao
                    ) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(48.dp)
                                .padding(horizontal = 8.dp),
                            horizontalArrangement = Arrangement.SpaceEvenly,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            val menuSelected = tab == AppTab.HUB || tab == AppTab.FORM ||
                                tab == AppTab.ORDEM_SERVICO || tab == AppTab.FUNCIONARIOS || tab == AppTab.FICHA_EPI ||
                                tab == AppTab.CERTIFICADO || tab == AppTab.APR || tab == AppTab.ATIVOS
                            TextButton(onClick = {
                                controller.solicitarSaidaDoFormulario { controller.abrirHubSecao(HubSecao.RAIZ) }
                            }) {
                                Text(
                                    "Menu",
                                    fontWeight = if (menuSelected) FontWeight.Bold else FontWeight.Normal,
                                    color = if (menuSelected) {
                                        MaterialTheme.colorScheme.primary
                                    } else {
                                        MaterialTheme.colorScheme.onSurfaceVariant
                                    }
                                )
                            }
                            TextButton(onClick = { controller.solicitarSaidaDoFormulario { controller.irPara(AppTab.HISTORICO) } }) {
                                Text(
                                    "Histórico",
                                    fontWeight = if (tab == AppTab.HISTORICO) FontWeight.Bold else FontWeight.Normal,
                                    color = if (tab == AppTab.HISTORICO) {
                                        MaterialTheme.colorScheme.primary
                                    } else {
                                        MaterialTheme.colorScheme.onSurfaceVariant
                                    }
                                )
                            }
                        }
                    }
                }
            },
            snackbarHost = { SnackbarHost(snackbar) }
        ) { padding ->
            Column(Modifier.padding(padding).fillMaxSize()) {
                when (tab) {
                    AppTab.HUB -> SharedFormHubScreen(controller = controller)
                    AppTab.FORM -> {
                        when (formTipoAtivo) {
                            FormTipo.INSPECAO_CAMPO ->
                                SharedFormScreen(controller = controller, embedded = true)
                            FormTipo.CHECKLIST_DIARIO_HTMS,
                            FormTipo.CHECKLIST_DIARIO_AXIA ->
                                SharedChecklistDiarioScreen(controller = controller)
                            FormTipo.RELATORIO_FOTO_ALOJAMENTO ->
                                SharedRelatorioFotoScreen(controller = controller)
                            FormTipo.CHECKLIST_ALOJAMENTO ->
                                SharedChecklistAlojamentoScreen(controller = controller)
                            FormTipo.CHECKLIST_VETORES ->
                                SharedChecklistVetoresScreen(controller = controller)
                            FormTipo.RELATORIO_ALOJAMENTO ->
                                SharedRelatorioAlojamentoScreen(controller = controller)
                            FormTipo.COMUNICACAO_OCORRENCIAS ->
                                SharedComunicacaoOcorrenciasScreen(controller = controller)
                            FormTipo.REM_SEGURANCA_OBRAS ->
                                SharedRemSegurancaScreen(controller = controller)
                            FormTipo.RELATORIO_SEGURANCA ->
                                SharedRelatorioSegurancaScreen(controller = controller)
                            FormTipo.ACOMPANHAMENTO_AMBIENTAL ->
                                SharedAcompanhamentoAmbientalScreen(controller = controller)
                            FormTipo.EVIDENCIA_TREINAMENTO ->
                                SharedEvidenciaTreinamentoScreen(controller = controller)
                            FormTipo.ANALISE_VISUAL_NR -> {
                                if (!FormTipo.ANALISE_VISUAL_NR_ATIVA) {
                                    LaunchedEffect(Unit) {
                                        controller.voltarAoHub()
                                    }
                                } else {
                                    SharedAnaliseVisualNrScreen(controller = controller)
                                }
                            }
                        }
                    }
                    AppTab.HISTORICO -> {
                        LaunchedEffect(tab) {
                            controller.atualizarHistoricoRemoto()
                        }
                        SharedHistoricoScreen(controller = controller, snackbar = snackbar)
                    }
                    AppTab.ORDEM_SERVICO -> {
                        if (authUser?.podeEmitirDocumentos(appConfig) == true &&
                            ColabEscopo.mostra(authUser, appConfig, ColabEscopo.DOC_OS)
                        ) {
                            SharedOrdemServicoScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.FUNCIONARIOS -> {
                        val subFunc by controller.funcionariosSubAba.collectAsState()
                        val chaveFunc = when (subFunc) {
                            "DASHBOARD" -> ColabEscopo.DOC_DASHBOARD
                            "IMPORTAR" -> ColabEscopo.DOC_IMPORTAR
                            else -> ColabEscopo.DOC_FUNCIONARIOS
                        }
                        if (authUser?.podeEmitirDocumentos(appConfig) == true &&
                            ColabEscopo.mostra(authUser, appConfig, chaveFunc)
                        ) {
                            SharedFuncionariosScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.FICHA_EPI -> {
                        if (authUser?.podeEmitirDocumentos(appConfig) == true &&
                            ColabEscopo.mostra(authUser, appConfig, ColabEscopo.DOC_EPI)
                        ) {
                            SharedFichaEpiScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.CERTIFICADO -> {
                        if (authUser?.podeEmitirDocumentos(appConfig) == true &&
                            ColabEscopo.mostra(authUser, appConfig, ColabEscopo.DOC_CERTIFICADO)
                        ) {
                            SharedCertificadoScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.APR -> {
                        if (authUser?.podeEmitirDocumentos(appConfig) == true &&
                            ColabEscopo.mostra(authUser, appConfig, ColabEscopo.DOC_APR)
                        ) {
                            SharedAprScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.ATIVOS -> {
                        if (authUser?.podeAcessarAtivos(appConfig) == true) {
                            SharedAtivosScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.COLABORADORES -> {
                        if (authUser?.podeAcessarColaboradores == true) {
                            SharedColaboradoresScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.EFETIVO -> {
                        if (authUser?.podeAcessarEfetivo == true) {
                            SharedEfetivoScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.OCORRENCIAS -> {
                        if (authUser?.podeAcessarOcorrencias == true) {
                            SharedOcorrenciasScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.DASHBOARDS -> SharedDashboardsScreen(controller = controller)
                    AppTab.ESTOQUE -> {
                        if (authUser?.podeAcessarEstoque == true) {
                            SharedEstoqueScreen(controller = controller)
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                    AppTab.CONFIG -> {
                        if (authUser?.isMaster == true) {
                            SharedConfigScreen(
                                controller = controller,
                                snackbar = snackbar,
                                headerActions = configHeaderActions,
                                onVoltar = { controller.voltarDaConfig() }
                            )
                        } else {
                            LaunchedEffect(Unit) { controller.voltarAoHub() }
                        }
                    }
                }
            }
        }
        } // KeyboardDismissHost
    }

    if (!isWeb) {
        Box(modifier = Modifier.fillMaxSize()) {
            appScaffold()
            EnvioProgressoOverlay(envio) { controller.fecharEnvioProgresso() }
        }
        return
    }

    Box(modifier = Modifier.fillMaxSize()) {
        WebCenteredColumn(
            larga = true,
            content = appScaffold
        )
        EnvioProgressoOverlay(envio) { controller.fecharEnvioProgresso() }
    }
}

/**
 * Bloqueia a tela durante o envio (dados → PDF → Excel).
 * Trocar de aba/fechar no meio deixava a inspeção sem PDF no servidor.
 */
@Composable
private fun EnvioProgressoOverlay(estado: EnvioProgresso, onFechar: () -> Unit) {
    if (!estado.ativo) return
    LaunchedEffect(estado.concluido, estado.falhou) {
        if (estado.concluido && !estado.falhou) {
            delay(1500)
            onFechar()
        }
    }
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black.copy(alpha = 0.55f))
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
                onClick = {}
            ),
        contentAlignment = Alignment.Center
    ) {
        Surface(
            shape = RoundedCornerShape(16.dp),
            color = MaterialTheme.colorScheme.surface,
            tonalElevation = 6.dp,
            modifier = Modifier
                .padding(24.dp)
                .widthIn(max = 340.dp)
        ) {
            Column(
                modifier = Modifier.padding(20.dp),
                verticalArrangement = Arrangement.spacedBy(10.dp)
            ) {
                Text(
                    text = when {
                        estado.falhou -> "Envio não concluído"
                        estado.concluido -> "Envio concluído"
                        else -> "Enviando ao servidor"
                    },
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.SemiBold
                )
                if (!estado.concluido) {
                    Text(
                        text = "Aguarde: não feche o navegador nem troque de aba.",
                        style = MaterialTheme.typography.bodySmall
                    )
                }
                LinearProgressIndicator(
                    progress = { estado.percent / 100f },
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(8.dp)
                )
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Text(
                        text = estado.etapa,
                        style = MaterialTheme.typography.bodySmall,
                        modifier = Modifier.weight(1f, fill = false)
                    )
                    Text(
                        text = "${estado.percent}%",
                        style = MaterialTheme.typography.bodySmall,
                        fontWeight = FontWeight.Bold
                    )
                }
                estado.detalhe?.let {
                    Text(text = it, style = MaterialTheme.typography.bodySmall)
                }
                if (estado.concluido) {
                    TextButton(
                        onClick = onFechar,
                        modifier = Modifier.align(Alignment.End)
                    ) {
                        Text("Fechar")
                    }
                }
            }
        }
    }
}

/** Web: fundo HTMS + coluna central (~60%) — login e app usam a mesma proporção. */
@Composable
private fun WebCenteredColumn(
    transparentCenter: Boolean = false,
    larga: Boolean = false,
    content: @Composable () -> Unit
) {
    BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
        HtmsBackdrop(modifier = Modifier.fillMaxSize())
        val columnWidth = if (larga && maxWidth >= 900.dp) {
            maxWidth * 0.96f
        } else if (maxWidth >= 900.dp) {
            (maxWidth * 0.72f).coerceIn(560.dp, 1000.dp)
        } else {
            maxWidth
        }
        Box(
            modifier = Modifier
                .width(columnWidth)
                .fillMaxHeight()
                .align(Alignment.Center)
                .then(
                    if (transparentCenter) Modifier
                    else Modifier.background(MaterialTheme.colorScheme.background)
                )
        ) {
            content()
        }
    }
}
